import React, { useEffect, useState } from "react";
import StudentsSearchSec from "./StudentsSearchSec";
import StudentsTable from "./StudentsTable";
import NoStudents from "./NoStudents";
import { getAllStudents } from "../../../../api/globalAdmin/Index";
import WebUtils from "../../../../utils/WebUtils";
import Utils from "../../../../utils/Utils";
import { Pagination } from "antd";

const ViewBatchStudents = ({
  selectedBatch,
  setCreateBatchFlag,
  setRefressGetApi,
  refressGetApi,
  setLoading,
  batchDetails,
  setBatchDetails,
  setSelectedUserIds,
  selectedUserIds,
  setStudentsData,
  studentsData,
  onAssignGuide,
  onAssignMockInterview,
}) => {
  const userDetail = Utils.getUserDetail();

  const [sortBy, setSortBy] = useState("SORT_BY_CREATION_DATE_DESC");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);

  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const getStudents = (pageNo, pageSize, searchInput) => {
    const url = `${getAllStudents}?organizationId=${
      userDetail?.organizationId || null
    }&batchIdentifier=${selectedBatch}&pageNumber=${pageNo}&pageSize=${pageSize}&sortBy=${sortBy}&searchValue=${searchInput}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBatchDetails(result?.data?.data);
          setStudentsData(result?.data?.data?.batchCandidateData);
          setPageCount(result?.data?.data?.totalCandidateCount);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };

  const sortItems = [
    {
      key: "SORT_BY_CREATION_DATE_ASC",
      label: "Creation Date (Old-New)",
    },
    {
      key: "SORT_BY_CREATION_DATE_DESC",
      label: "Creation Date (New-Old)",
    },
    {
      key: "SORT_BY_CANDIDATE_NAME_ASC",
      label: "Candidate Name (A-Z)",
    },
    {
      key: "SORT_BY_CANDIDATE_NAME_DESC",
      label: "Candidate Name (Z-A)",
    },
  ];

  useEffect(() => {
    getStudents(currentPage, pageSize, searchValue);
  }, [pageSize, currentPage, sortBy, refressGetApi, searchValue]);

  // Check if there's an active search and no results
  const hasActiveSearch = searchValue && searchValue.trim() !== "";
  const noSearchResults = hasActiveSearch && (!studentsData || studentsData.length === 0);
  const noStudentsAtAll = (!hasActiveSearch || !searchValue) && (!studentsData || studentsData.length === 0);

  const refreshStudents = () => {
    getStudents(currentPage, pageSize, searchValue);
  };

  return (
    <div>
      {(studentsData?.length > 0) ? (
        <>
          <StudentsSearchSec
            studentsData={studentsData}
            setCreateBatchFlag={setCreateBatchFlag}
            setRefressGetApi={setRefressGetApi}
            setSortBy={setSortBy}
            sortBy={sortBy}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            searchText={searchText}
            setSearchText={setSearchText}
            sortItems={sortItems}
          />

          <StudentsTable
            selectedBatch={selectedBatch}
            studentsData={studentsData}
            setSelectedUserIds={setSelectedUserIds}
            selectedUserIds={selectedUserIds}
            onAssignGuide={onAssignGuide}
            onAssignMockInterview={onAssignMockInterview}
            onRefreshStudents={refreshStudents}
            setLoading={setLoading}
          />
          <div className="flex justify-center mt-3 mb-1">
            <Pagination
              current={currentPage + 1}
              total={pageCount}
              pageSize={pageSize}
              onChange={onPageChange}
              showSizeChanger={true}
              pageSizeOptions={["5", "10", "15", "20"]}
            />
          </div>
        </>
      ) : noSearchResults ? (
        // Display "No search results found" message
        <div className="text-center py-8">
          {/* <div className="text-gray-500 mb-2">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div> */}
          <h3 className="text-lg font-medium text-gray-900 mb-1">
            No search results found
          </h3>
          <p className="text-gray-500">
            No students match "{searchValue}". Please try a different search term.
          </p>
          <button
            onClick={() => {
              setSearchValue("");
              setSearchText("");
            }}
            className="mt-4 px-4 py-2 btn-orange rounded-md"
          >
            Clear Search
          </button>
        </div>
      ) : noStudentsAtAll ? (
        <NoStudents setCreateBatchFlag={setCreateBatchFlag} />
      ) : null}
    </div>
  );
};

export default ViewBatchStudents;